type NewTabClickEvent = {
  button?: number
  ctrlKey: boolean
  metaKey: boolean
  shiftKey: boolean
}

/**
 * True when the user asked the browser to open a target outside the current
 * tab: Cmd + click (macOS), Ctrl + click (Windows/Linux), Shift + click or
 * middle-click. Matches the modifier check in DrawerBreadcrumb and the dark
 * package's LocationBreadcrumb. On a real link the browser opens Shift + click
 * in a new window; `openInNewTab` opens a tab, but either way the current tab
 * is left alone.
 */
export const isNewTabClick = (event: NewTabClickEvent): boolean =>
  event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1

export const openInNewTab = (href: string): void => {
  window.open(href, '_blank', 'noopener,noreferrer')
}
